import React from "react";
import ManageAwardContainer from "../../containers/configuration/ManageAward";

const ManageAward = () => {
  return <ManageAwardContainer />
};

export default ManageAward;
